module.exports = __webpack_public_path__ + "img/00233065002554.63af10be.png";